import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import RocketIcon from '@mui/icons-material/Rocket';
import NextPlanIcon from '@mui/icons-material/NextPlan';
const verticaltimeline= () => (
    
<VerticalTimeline>
  <VerticalTimelineElement
    className="vertical-timeline-element--work"
    contentStyle={{ background: '#8264e2', color: '#fff' }}
    contentArrowStyle={{ borderRight: '7px solid  rgb(33, 150, 243)' }}
    date="2021 Q4."
    iconStyle={{ background: 'rgb(40, 69, 173)', color: '#fff' }}
    icon={<RocketIcon />}
  >
    <h3 className="vertical-timeline-element-title">MerryTerraChristmas</h3>
    <p>
    Team building, Idea formulation, Merry Terra Christmas reveal
    </p>
  </VerticalTimelineElement>

  <VerticalTimelineElement
    className="vertical-timeline-element--work"
    contentStyle={{ background: '#8264e2', color: '#fff' }}
    contentArrowStyle={{ borderRight: '7px solid  rgb(33, 150, 243)' }}
    date="2021 Q4."
    iconStyle={{ background: 'rgb(40, 69, 173)', color: '#fff' }}
    icon={<RocketIcon />}
  >
    <h3 className="vertical-timeline-element-title">Merry Terra Christmas Public Mint</h3>
    <p>
    3,600+ randomely generated Seals are minted into the Terraverse. It is the first charity-oriented NFT project on Terra. 80% of the mint proceed will be donated to Angel Protocol.
    </p>
  </VerticalTimelineElement>

  <VerticalTimelineElement
    className="vertical-timeline-element--work"
    contentStyle={{ background: '#ff7f00', color: '#fff' }}
    contentArrowStyle={{ borderRight: '7px solid  #ffc0cb' }}
    date="2022 Q1."
    iconStyle={{ background: '#ff4500', color: '#fff' }}
    icon={<NextPlanIcon />}
  >
    <h3 className="vertical-timeline-element-title">Marketplace</h3>
    <p>
    MTC seals will be made tradable on OnePlanet V1.
    </p>
  </VerticalTimelineElement>

  <VerticalTimelineElement
    className="vertical-timeline-element--work"
    contentStyle={{ background: '#ff7f00', color: '#fff' }}
    contentArrowStyle={{ borderRight: '7px solid  #ffc0cb' }}
    date="2022 Q2."
    iconStyle={{ background: '#ff4500', color: '#fff' }}
    icon={<NextPlanIcon />}
  >
    <h3 className="vertical-timeline-element-title">Multi-chain expansion</h3>
    <p>
    Solana, Ethereum
    </p>
  </VerticalTimelineElement>

  <VerticalTimelineElement
    className="vertical-timeline-element--work"
    contentStyle={{ background: '#ff7f00', color: '#fff' }}
    contentArrowStyle={{ borderRight: '7px solid  #ffc0cb' }}
    date="2022 Q3."
    iconStyle={{ background: '#ff4500', color: '#fff' }}
    icon={<NextPlanIcon />}
  >
    <h3 className="vertical-timeline-element-title">MTC DAO V1</h3>
    <p>
    Launch a social voting system for MTC holders to govern the future vision of the project.    
    </p>
  </VerticalTimelineElement>

  <VerticalTimelineElement
    className="vertical-timeline-element--work"
    contentStyle={{ background: '#ff7f00', color: '#fff' }}
    contentArrowStyle={{ borderRight: '7px solid  #ffc0cb' }}
    date="2022 Q4."
    iconStyle={{ background: '#ff4500', color: '#fff' }}
    icon={<NextPlanIcon />}
  >
    <h3 className="vertical-timeline-element-title">MTC Seals V2</h3>
    <p>
    Christmas Seals NFTs with a different theme selected by community event. We will make this a yearly event!
    </p>
  </VerticalTimelineElement>
  <VerticalTimelineElement
    className="vertical-timeline-element--work"
    contentStyle={{ background: '#ff7f00', color: '#fff' }}
    contentArrowStyle={{ borderRight: '7px solid  #ffc0cb' }}
    date="2023 Q1."
    iconStyle={{ background: '#ff4500', color: '#fff' }}
    icon={<NextPlanIcon />}
  >
    <h3 className="vertical-timeline-element-title">Hackathon</h3>
    <p>
    Our mission is to make a sustainable NFT ecosystem on Terra. We will host a hackathon to encourage builders, artists and creators to bring their ideas and build on Terra.  
    </p>
  </VerticalTimelineElement>

  
</VerticalTimeline>
    );
    export default verticaltimeline;

